var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "currentColor", fillRule: "evenodd" },
            React.createElement("path", { d: "M24 6c8.284 0 15 6.716 15 15a14.96 14.96 0 01-4.873 11.065l4.255 7.371-4.761.021-2.4 4.113-4.511-7.814a15.087 15.087 0 01-5.072.06l-4.477 7.754-2.4-4.113-4.761-.02 4.126-7.145A14.965 14.965 0 019 21c0-8.284 6.716-15 15-15zm0 4c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11-4.925-11-11-11z" }),
            React.createElement("path", { d: "M24 25.66l-4.513 1.374-.087-4.717-2.702-3.867 4.459-1.54L24 13.144l2.843 3.764 4.46 1.54-2.703 3.868-.087 4.717z" }))));
});
